import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ServiceCard from "../ServiceCard/ServiceCard";
import "./Careers.scss";
import { graphql, useStaticQuery } from "gatsby";

import {PageLinks} from '../../components/common/constant';

const Careers = (props) => {
    const data = useStaticQuery(graphql`
        query {
            glstrapi {
                careers(publicationState: LIVE, where: {Publish: true},sort:"Sort:asc") {
                    _id
                    Title
                    Description
                    Url
                    Video_Url
                    Meta_Title
                    Meta_Description
                    Content
                    Alias
                    Sort
                    Publish
                    Tile_Image {
                      url
                      alternativeText
                    }
                }
            }
        }
    `);

    return (
        <Container className='module-container' id="career-list">
            <Row>
                <Col md={12}>
                    <section className="service-list module-wrap-list mx-auto">
                        <span className='sm-text'>{props?.data?.Title?.split("\n\n")?.[0]}</span>
                        <h2>{props?.data?.Title?.split("\n\n")?.[1]}</h2>
                        {data?.glstrapi?.careers?.map((property, index) => {    
                            var detail_url = `/${PageLinks.career_url}/${property.Url}/`                    
                            return(
                                <ServiceCard 
                                    key={index} 
                                    serviceValue={{
                                        serviceImg: property?.Tile_Image?.url,
                                        serviceTitle: property.Title,
                                        serviceContent: property.Description,
                                        serviceLink: detail_url
                                    }} 
                                />
                            )}
                        )}
                    </section>
                </Col>
            </Row>
        </Container>
    )
} 

export default Careers;